export default "__VITE_ASSET__DtEweW1M__"